import * as React from 'react'
require('../base.module.scss')
import * as st from './MoreContent.module.scss'
import { uniqueId } from 'DVWebNodeUtils'

const FALLBACK_STRING = '…'

interface MoreContentProps {
    index?: number,
    moreString?: string,
    visible: any,
    hidden: any
}
interface MoreItemProps {
    id: string|number,
    string?: string
}

export const MoreItem = ({ string, id }: MoreItemProps) => (
  <React.Fragment>
    <input className={st['more-item-input']} type="checkbox" id={`more-content-toggle-${id}`}/>
    <label className={st['more-item']} htmlFor={`more-content-toggle-${id}`}>
      {string || FALLBACK_STRING}
    </label>
  </React.Fragment>
)

export const MoreContent: React.ComponentType<MoreContentProps> = (props: MoreContentProps) => (<React.Fragment>
  {props.visible}
  <MoreItem string={props.moreString} id={props.index || uniqueId()} />
  <span className={st['more-item-hidden']}>{props.hidden}</span>
</React.Fragment>)

// Add displayName to preserve the component name on snapshot testing
MoreContent.displayName = 'MoreContent'
